import { render, staticRenderFns } from "./ContentItemsViewStatsCard.vue?vue&type=template&id=2ac972b4&"
import script from "./ContentItemsViewStatsCard.vue?vue&type=script&lang=js&"
export * from "./ContentItemsViewStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports